import { useMessages } from '@features/l10n/l10nInjector.js';
import { Emoji } from '@shared/components/Emoji.js';
import { MenuLabel } from '@shared/components/MenuLabel.js';
import { SubmenuHeader } from '@shared/components/SubmenuHeader.js';
import { useAppSelector } from '@shared/hooks/useAppSelector.js';
import type { JSX } from 'react';
import { Dropdown } from 'react-bootstrap';
import { IoLanguage } from 'react-icons/io5';
import { languageItems } from './languageItems.js';

export function LanguageSubmenu(): JSX.Element {
  const m = useMessages();

  const chosenLanguage = useAppSelector((state) => state.l10n.chosenLanguage);

  return (
    <>
      <SubmenuHeader icon={<IoLanguage />} title={m?.mainMenu.language} />

      <Dropdown.Item
        as="button"
        eventKey="lang-"
        active={chosenLanguage === null}
      >
        <MenuLabel>{m?.mainMenu.automaticLanguage}</MenuLabel>
      </Dropdown.Item>

      {languageItems.map(({ code, name, flag }) => (
        <Dropdown.Item
          key={code}
          as="button"
          eventKey={`lang-${code}`}
          active={chosenLanguage === code}
        >
          <Emoji>{flag}</Emoji>
          <MenuLabel>{name}</MenuLabel>
        </Dropdown.Item>
      ))}
    </>
  );
}
